import BL from './bl'
import clone from '@/utils/clone'

const compareMultiSelectValues = function (userVal, filterVal) {
  if (!Array.isArray(filterVal)) {
    return true
  }
  return userVal.some(val => filterVal.includes(val))
}

const compareSelectValues = function (userVal, filterVal) {
  if (!Array.isArray(filterVal)) {
    return true
  }
  return filterVal.includes(userVal)
}

const mergeQuestionInGroup = function (question, group) {
  switch (question.type.type) {
    case 'bool':
      group.key = question.key
      group.form_label = question.form_label
      group.type = question.type
      break
    case 'select':
    case 'multiselect':
    case 'select_with_freetext':
      group.form_label = question.form_label
      const additionalOptions = question.type.options.map(option => ({
        label: option,
        questionKey: question.key
      }))
      if (!group.type) {
        group.type = {
          options: additionalOptions,
          type: 'multiselect'
        }
      } else {
        group.type.options = group.type.options.concat(additionalOptions)
      }
      break
    default:
      throw new Error('invalid question type')
  }
  return group
}

const filterBL = {
  filterCandidates (candidates, filterAnswers, questions) {
    return candidates.filter(candidate => {
      let visible = true
      const questionKeys = Object.keys(filterAnswers)
      questionKeys.forEach(key => {
        if (filterAnswers[key] === undefined) {
          visible = visible && true
          return
        }
        const type = questions.find(q => q.key === key).type.type
        const answer = BL.getAnswerForQuestionKey(key, candidate.answers)
        if (!answer) {
          visible = visible && false
        }
        switch (type) {
          case 'bool':
            visible = visible && answer.answer === filterAnswers[key]
            break
          case 'select':
          case 'select_with_freetext':
            visible = visible && compareSelectValues(answer.answer, filterAnswers[key])
            break
          case 'multiselect':
            visible = visible && compareMultiSelectValues(answer.answer, filterAnswers[key])
            break
          default:
            throw new Error('Unsupported QuestionType')
        }
      })
      return visible
    })
  },

  computeFilterQuestions (questions) {
    // Filter Questions bestimmen
    const filterQuestions = clone(questions
      .filter(question => question.metadata.use_as_filter_option)
      .sort((q1, q2) => {
        if (q1.type.type === q2.type.type) {
          return 0
        }
        if (q1.type.type === 'bool') {
          return 1
        } else {
          return -1
        }
      })
    )
    // Filter gruppieren
    const filterQuestionMap = {}
    filterQuestions.forEach(question => {
      const groupId = question.form_label.trim()
      if (!filterQuestionMap[groupId]) {
        filterQuestionMap[groupId] = {}
      }
      mergeQuestionInGroup(question, filterQuestionMap[groupId])
    })
    return filterQuestionMap
  }
}

export default filterBL
